<template>
  <div>
    <a href="#" class="clickable" @click.prevent="exportAllDecomptes">
      Exporter l'intégralité des résultats au format csv
    </a>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options">
      <div slot="salarie" slot-scope="props" class="formatted-box">
        <b>{{ props.row.nom_pp }} {{ props.row.prenom_pp }}</b> <br>
        <span style="color: #2139ff;">{{ props.row.nir_pp }}</span>
      </div>
      <div slot="categorie" slot-scope="props" class="formatted-box">
        <span v-if="props.row.cat_sal"><b>{{ props.row.cat_sal }}</b></span>
        <span v-else><b>N.D.</b></span> <br>
        <span>NIC : {{ Number(props.row.siret_pm_site.substring(props.row.siret_pm_site.length - 5)) }}</span>
        <i :id="`tooltip-${props.row.presta_id}`" class="fa fa-info clickable ml-4"></i>
        <b-tooltip :target="`tooltip-${props.row.presta_id}`" triggers="hover">
          <span>{{ props.row.raison_sociale }}</span><br>
          {{ getFormattedSiret(props.row.siret_pm_site) }}
        </b-tooltip>
      </div>
      <div slot="periode_arret" slot-scope="props" class="formatted-box">
        du {{ formatDate(props.row.date_deb_prest) }} <br>
        au {{ formatDate(props.row.date_fin_prest) }}
      </div>
      <div slot="nature" slot-scope="props" class="formatted-box">
        {{ props.row.lib_cause }} <br>
        <span>{{ props.row.nb_jour }} j.</span>
      </div>
      <div slot="produit" slot-scope="props" class="formatted-box">
        <b>{{ props.row.produit }}</b> <br>
        <i>{{ props.row.lib_gar }}</i>
      </div>
      <div slot="prise_en_charge" slot-scope="props" class="formatted-box">
        <i>{{ getPriseEnCharge(props.row.prise_en_charge, props.row.lib_type_prest) }} </i><br>
        <span v-if="props.row.total_presta > 0"> <b>+ {{ replaceDotToComma(formatNumber(props.row.total_presta)) }} €</b></span>
        <span style="color:#ce0b35" v-else-if="props.row.total_presta < 0"><b>{{ replaceDotToComma(formatNumber(props.row.total_presta)) }} €</b></span>
        <span v-else> - </span>
      </div>
      <div slot="date_traitement" slot-scope="props" class="formatted-box">
        {{ formatDate(props.row.date_traitement) }} <br>
        <span style="color: #2139ff;">{{ props.row.num_decompte }}</span>
      </div>
      <div slot="action" slot-scope="props" class="formatted-box">
        <img style="width: 15px;" class="mr-2 clickable" :src="getIcon('pdf')" @click="generatePDFFromPeriodes(props.row.num_decompte, props.row.decompte_id)">
        <i v-if="isNotArchive(props.row,'prestation')" v-b-tooltip.hover title="Archiver" class="fa fa-folder clickable text-warning" @click="updateStatus('prestation', 'archive', props.row.presta_id)"></i>
        <i v-else v-b-tooltip.hover title="Désarchiver" class="fa fa-folder-open clickable text-secondary" @click="updateStatus('prestation', 'a_traiter', props.row.presta_id)"></i>
        <br>
        <span style="font-size: 13px"><i>Période {{ getLibelleStatutPrestation(props.row) }}</i></span>
      </div>
      <div slot="selection" slot-scope="props" class="formatted-box">
        <b-form-checkbox v-model="selectedRows_2" :value="props.row.presta_id" :state="errors.checkbox_2 === ''"></b-form-checkbox>
      </div>
      <div slot="h__selection">
        <b-form-checkbox
          v-model="allSelected_2"
          :indeterminate="indeterminate_2"
          aria-describedby="items"
          aria-controls="items"
          @change="toggleAll">
        </b-form-checkbox>
      </div>
    </v-server-table>
    <b-row>
      <b-col md="6"><button @click.prevent="goBackMainSearch()" type="button" class="btn btn-warning" variant="warning"><i class="fa fa-arrow-left"></i> Retour</button></b-col>
      <b-col md="6" style="display: inline-flex;flex-direction: row;">
        <b-form-group label-for="action_2" class="mr-2" style="order: 0;flex-grow: 1;height:15px;">
          <b-form-select
            id="action_2"
            :plain="true"
            :options="action_2_options"
            v-model="selectedOption2">
          </b-form-select>
        </b-form-group>
        <button type="button" style="order: 1" class="btn btn-primary" @click="triggerAction">OK</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {formatDate, formatNumber, replaceDotToComma } from "@/utils/communHelper";
  import {isEmpty, getFileIcon} from "@/utils/fileHelper";

  export default {
    name: "DecomptesTable",
    props: ["tableEntry"],
    data() {
      let self = this;
      return {
        url: '',
        allSelected_2: [],
        selectedRows_2: [],
        indeterminate_2: false,
        action_2_options: [
          {value: 'null', text: 'Action sur la séléction'},
          {value: 'archive', text: 'Archiver'},
          {value: 'a_traiter', text: 'Désarchiver'},
          {value: 'export_csv', text: 'Export CSV'},
        ],
        selectedOption2: null,
        columns: ['salarie', 'categorie', 'periode_arret', 'nature', 'produit', 'prise_en_charge', 'date_traitement', 'action', 'selection'],
        items: [],
        searchData: [],
        options: {
          headings: {
            'salarie': 'Nom Prénom \nNIR',
            'categorie': 'Catégorie \nAffiliation',
            'periode_arret': "Période d'arrêt",
            'nature': 'Nature \nJours',
            'produit': 'Produit \nType Garantie',
            'prise_en_charge': 'Prise en charge \nMontant',
            'date_traitement': 'Date trait \nN°décompte',
            'action': 'Action Période \nStatut Période',
            'selection': '',
          },
          columnsClasses: {
            salarie: 'pre-formatted sort-top position-r',
            categorie: 'pre-formatted sort-top position-r',
            periode_arret: 'pre-formatted sort-top position-r',
            nature: 'pre-formatted sort-top position-r',
            produit: 'pre-formatted sort-top position-r',
            date_traitement: 'pre-formatted sort-top position-r',
            prise_en_charge: 'pre-formatted sort-top position-r',
            action: 'pre-formatted sort-top text-center position-r',
            selection: 'pre-formatted align-middle text-center sort-top position-r',
          },
          sortable: ["date_traitement"],
          filterable: false,
          perPage: 10,
          perPageValues: [10, 25, 50],
          requestFunction: function (data) {
            if(self.tableEntry.show_periodes) {
              self.url = '/espaceGestion/decomptesIJ/afficherPeriodes';
              data["decompte_ids"] = self.tableEntry.decompte_ids;
            }
            else {
              self.url = '/espaceGestion/decomptesIJ/search';
              data["numero_decompte"] = self.tableEntry.numero_decompte;
              data["montant_decompte"] = self.tableEntry.montant_decompte;
              data["type_decompte"] = self.tableEntry.type_decompte;
              data["statut_decompte"] = self.tableEntry.statut_decompte;
              data["date_debut_decompte"] = self.tableEntry.date_debut_decompte;
              data["date_fin_decompte"] = self.tableEntry.date_fin_decompte;
              data["siren"] = self.tableEntry.siren;
              data["nic"] = self.tableEntry.nic;
              data["raison_sociale"] = self.tableEntry.raison_sociale;
              data["numero_contrat"] = self.tableEntry.numero_contrat;
              data["famille_produit"] = self.tableEntry.famille_produit;
              data["nom_cev"] = self.tableEntry.nom_cev;
              data["prenom_cev"] = self.tableEntry.prenom_cev;
              data["email_cev"] = self.tableEntry.email_cev;
              data["nom_salarie"] = self.tableEntry.nom_salarie;
              data["prenom_salarie"] = self.tableEntry.prenom_salarie;
              data["nir_salarie"] = self.tableEntry.nir_salarie;
              data['noSearch'] = self.tableEntry.noSearch;
              if (self.tableEntry.noSearch !== 'noSearch') {
                self.$store.commit('IS_LOADING', true);
              }
            }
            return axios.get(self.url, {params: data})
              .then(function (response) {
                if (self.tableEntry.noSearch !== 'noSearch') {
                  self.$store.commit('IS_LOADING', false);
                }
                self.searchData = data;
                return response;
              })
              .catch(function (e) {
                self.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                });
              }
              .bind(this));
          }
        },
        formatDate,
        formatNumber,
        replaceDotToComma,
        isEmpty,
        errors: {
          checkbox_2: '',
        },
      };
    },
    methods: {
      onLoaded(){
        this.$store.commit("IS_LOADING", false);
      },
      toggleAll(checked) {
        this.selectedRows_2 = checked ? this.$refs.table.data.map(item => item.presta_id) : [];
      },
      getPriseEnCharge(prise_en_charge, lib_type_prest) {
        if (prise_en_charge === '' && lib_type_prest.toLowerCase() === 'franchise') {
          prise_en_charge = 'Franchise';
        } else if (prise_en_charge === '') {
          prise_en_charge = lib_type_prest.toLowerCase();
        }
        return prise_en_charge;
      },
      getIcon(extension) {
        let images = require.context('../../../assets/images/', false, /^\.\/\S+.*\.[a-zA-Z]+$/);
        let extensionIcon = getFileIcon();
        return images('./' + extensionIcon[extension]);
      },
      triggerAction() {
        this.$emit('actions-from-periodes', { action: this.selectedOption2, rows: this.selectedRows_2 });
      },
      getLibelleStatutPrestation(decompte) {
        let libelle = '';
        if (isEmpty(decompte.presta_statut_id)) {
          let statusPresta = _.find(this.$parent.allStatus, (status) => parseInt(status.id,10) === parseInt(decompte.statut_id,10));
          if (!isEmpty(statusPresta)) {
            libelle = statusPresta.libelle_bo;
          }
        } else {
          let statusPresta = _.find(this.$parent.allStatus, (status) => parseInt(status.id,10) === parseInt(decompte.presta_statut_id,10));
          if (!isEmpty(statusPresta)) {
            libelle = statusPresta.libelle_bo;
          }
        }

        return libelle;
      },
      getFormattedSiret(siret){
        if (siret.length === 9) {
          return siret.substring(0,3)+' '+siret.substring(3,3)+' '+siret.substring(6,3);
        } else {
          return siret.substring(0,9)+' - '+siret.substring(siret.length - 5);
        }
      },
      goBackMainSearch() {
        this.$emit('go-back-main-search');
      },
      isNotArchive(decompte, type) {
        let decompteStatus = null;
        if (type === 'prestation') {
          // Certain presta_statut_id ne sont pas renseignés si on tombe sur un de ces cas, on prend le statut du décompte
          if (isEmpty(decompte.presta_statut_id)) {
            decompteStatus = _.find(this.$parent.allStatus, (status) => parseInt(status.id,10) === parseInt(decompte.statut_id,10));
          } else {
            decompteStatus = _.find(this.$parent.allStatus, (status) => parseInt(status.id,10) === parseInt(decompte.presta_statut_id,10));
          }
        } else {
          decompteStatus = _.find(this.$parent.allStatus, (status) => parseInt(status.id,10) === parseInt(decompte.statut_id,10));
        }
        return  (!(decompteStatus && decompteStatus.libelle_technique === 'archive'));
      },
      generatePDFFromPeriodes(numero_decompte, decompte_id) {
        this.$emit('generate-pdf-from-periodes', { numero_decompte: numero_decompte, decompte_id: decompte_id });
      },
      updateStatus(type, statut_libelle_technique, ids) {
        this.$emit('update-status-from-periodes', { type: type, statut_libelle_technique: statut_libelle_technique, ids: ids });
      },
      exportAllDecomptes() {
        if (this.searchData.length !== 0) {
          this.$emit('export-all-decomptes', { search_data: this.searchData, data: this.$refs['table'].data });
        }
      },
    }
  };
</script>

<style scoped>
  .VueTables__search-field input {
    width: 240px !important;
  }
</style>
